import { Routes } from '@angular/router';
import { Mainlayout } from './layouts/mainlayout/mainlayout';
import { capabilityGuard, landingGuard } from './core/guards/capability.guard';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { cambiosSinGuardarGuard } from './core/guards/cambios-sin-guardar.guard';

export const routes: Routes = [
    {
        path: 'login',
        pathMatch: 'full',
        canActivate: [guestGuard],
        loadComponent: () => import('./pages/login/login').then(m => m.Login)
    },
    {
        path: '',
        component: Mainlayout,
        canActivate: [authGuard],
        children: [
            {
                // El destino depende del rol: un tecnico no tiene panel principal.
                path: '',
                canActivate: [landingGuard],
                children: [],
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                canActivate: [capabilityGuard('panel:ver')],
                loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.Dashboard)
            },
            {
                path: 'activities',
                canActivate: [capabilityGuard('actividades:ver')],
                loadComponent: () => import('./pages/moduloactividades/actividades/actividades').then(m => m.Actividades)
            },
            {
                path: 'activities/create',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('actividades:crear')],
                loadComponent: () => import('./pages/moduloactividades/crearactividad/crearactividad').then(m => m.Crearactividad)
            },
            {
                path: 'activities/:id',
                canActivate: [capabilityGuard('actividades:ver')],
                loadComponent: () => import('./pages/moduloactividades/detallesactividad/detallesactividad').then(m => m.Detallesactividad)
            },
            {
                path: 'activities/edit/:id',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('actividades:crear')],
                loadComponent: () => import('./pages/moduloactividades/editaractividad/editaractividad').then(m => m.Editaractividad)
            },
            {
                path: 'assets',
                canActivate: [capabilityGuard('activos:ver')],
                loadComponent: () => import('./pages/moduloactivos/activos/activos').then(m => m.Activos)
            },
            {
                path: 'assets/create',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('activos:editar')],
                loadComponent: () => import('./pages/moduloactivos/crearactivo/crearactivo').then(m => m.Crearactivo)
            },
            {
                path: 'assets/:id',
                canActivate: [capabilityGuard('activos:ver')],
                loadComponent: () => import('./pages/moduloactivos/detallesactivo/detallesactivo').then(m => m.Detallesactivo)
            },
            {
                path: 'assets/edit/:id',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('activos:editar')],
                loadComponent: () => import('./pages/moduloactivos/editaractivo/editaractivo').then(m => m.Editaractivo)
            },
            {
                path: 'schedules',
                canActivate: [capabilityGuard('planes:ver')],
                loadComponent: () => import('./pages/moduloplanespreventivos/planespreventivos/planespreventivos').then(m => m.Planespreventivos)
            },
            {
                path: 'schedules/create',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('planes:editar')],
                loadComponent: () => import('./pages/moduloplanespreventivos/crearplanpreventivo/crearplanpreventivo').then(m => m.Crearplanpreventivo)
            },
            {
                path: 'schedules/:id',
                canActivate: [capabilityGuard('planes:ver')],
                loadComponent: () => import('./pages/moduloplanespreventivos/detallesplanpreventivo/detallesplanpreventivo').then(m => m.Detallesplanpreventivo)
            },
            {
                path: 'schedules/edit/:id',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('planes:editar')],
                loadComponent: () => import('./pages/moduloplanespreventivos/editarplanpreventivo/editarplanpreventivo').then(m => m.Editarplanpreventivo)
            },
            {
                path: 'checklists',
                canActivate: [capabilityGuard('checklists:ver')],
                loadComponent: () => import('./pages/modulochecklist/checklist/checklist').then(m => m.Checklist)
            },
            {
                path: 'checklists/create',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('checklists:editar')],
                loadComponent: () => import('./pages/modulochecklist/createchecklist/createchecklist').then(m => m.Createchecklist)
            },
            {
                path: 'checklists/:id',
                canActivate: [capabilityGuard('checklists:ver')],
                loadComponent: () => import('./pages/modulochecklist/detalleschecklist/detalleschecklist').then(m => m.Detalleschecklist)
            },
            {
                path: 'checklists/edit/:id',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('checklists:editar')],
                loadComponent: () => import('./pages/modulochecklist/editchecklist/editchecklist').then(m => m.Editchecklist)
            },
            {
                path: 'users',
                canActivate: [capabilityGuard('equipo:ver')],
                loadComponent: () => import('./pages/modulousuarios/usuarios/usuarios').then(m => m.Usuarios)
            },
            {
                path: 'users/create',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('equipo:editar')],
                loadComponent: () => import('./pages/modulousuarios/createusuario/createusuario').then(m => m.Createusuario)
            },
            {
                path: 'users/:id',
                canActivate: [capabilityGuard('equipo:ver')],
                loadComponent: () => import('./pages/modulousuarios/detailsusuario/detailsusuario').then(m => m.Detailsusuario)
            },
            {
                path: 'users/edit/:id',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('equipo:editar')],
                loadComponent: () => import('./pages/modulousuarios/editusuario/editusuario').then(m => m.Editusuario)
            },
            {
                path: 'work-units',
                canActivate: [capabilityGuard('unidades:ver')],
                loadComponent: () => import('./pages/modulounidadtrabajo/unidadtrabajo/unidadtrabajo').then(m => m.Unidadtrabajo)
            },
            {
                path: 'work-units/create',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('unidades:editar')],
                loadComponent: () => import('./pages/modulounidadtrabajo/createunidadtrabajo/createunidadtrabajo').then(m => m.Createunidadtrabajo)
            },
            {
                path: 'work-units/edit/:id',
                canDeactivate: [cambiosSinGuardarGuard],
                canActivate: [capabilityGuard('unidades:editar')],
                loadComponent: () => import('./pages/modulounidadtrabajo/editunidadtrabajo/editunidadtrabajo').then(m => m.Editunidadtrabajo)
            },
            {
                path: 'work-units/:id',
                canActivate: [capabilityGuard('unidades:ver')],
                loadComponent: () => import('./pages/modulounidadtrabajo/detailsunidadtrabajo/detailsunidadtrabajo').then(m => m.Detailsunidadtrabajo)
            },
            {
                path: 'branches',
                canActivate: [capabilityGuard('sedes:ver')],
                loadComponent: () => import('./pages/modulosedes/sedes/sedes').then(m => m.Sedes)
            },
            {
                path: 'reports',
                canActivate: [capabilityGuard('reportes:ver')],
                loadComponent: () => import('./pages/moduloreportes/reporte/reporte').then(m => m.Reporte)
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    }
];
